import React from 'react'
import PropTypes from 'prop-types'

class PositionSelect extends React.Component {
  state = {
    position_id: this.props.position_id,
    positions: _.sortBy(this.props.positions, ['priority', 'name'])
  }

  onPositionChange = (e) => {
    this.setState({ position_id: e.target.value })
    setTimeout(function() { this.props.newPositionCallback(this.state.position_id) }.bind(this), 50)
  }

  render() {
    var options = this.state.positions.map(function(position) {
      return (
        <option key={position.id}
                value={position.id}>
          {position.name}
        </option>
      )
    })

    return(
      <div className={this.props.selectClassName}>
        <select className='form-control'
                title='Position'
                value={this.state.position_id}
                onChange={(e) => this.onPositionChange(e)}>
          <option value=''>
            All Positions
          </option>
          {options}
        </select>
      </div>
    )
  }
}

PositionSelect.propTypes = {
  position_id: PropTypes.number,
  positions: PropTypes.array,
  selectClassName: PropTypes.string
}

export default PositionSelect
